import { render, staticRenderFns } from "./rg.vue?vue&type=template&id=7372a59c&scoped=true&"
import script from "./rg.vue?vue&type=script&lang=js&"
export * from "./rg.vue?vue&type=script&lang=js&"
import style0 from "./rg.vue?vue&type=style&index=0&id=7372a59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372a59c",
  null
  
)

export default component.exports